import { currentBrand } from 'config';

const ABSOLUTE_URL_REGEX = /^[a-z][a-z\d+\-.]*:\/\//i;

export function prependBrandInProduction(url?: string): string | undefined {
    if (!url || process.env.NODE_ENV !== 'production') {
        return url;
    }

    if (ABSOLUTE_URL_REGEX.test(url) || url.startsWith('//') || url.startsWith('data:')) {
        return url;
    }

    const path = url.startsWith('/') ? url : `/${url}`;
    const brandPrefix = `/${currentBrand}`;

    return path.startsWith(`${brandPrefix}/`) ? path : `${brandPrefix}${path}`;
}
